import {Navigation} from 'src/app/@theme/types/navigation';
import {PermissionKey} from '@mri/enums';

export const menus: Navigation[] = [
  {
    id: 'dashboard',
    url: '/console/panels/0',
    type: 'item',
    title: 'Dashboard',
    icon: '#custom-status-up',
    classes: 'nav-item',
  },
  {
    id: 'location',
    title: 'Ubicacion',
    type: 'item',
    classes: 'nav-item',
    url: '/console/trackers/list',
    icon: '#custom-global',
    permissions: [
      PermissionKey.CURRENT_MOBILE_LIST
    ]
  },
  {
    id: 'travel',
    title: 'Recorrido',
    type: 'item',
    classes: 'nav-item',
    url: '/console/reports/positions/list',
    queryParam: {
      '$view:mode': 'map',
      '$view:showFilter': 'true'
    },
    icon: '#custom-data',
    permissions: [
      PermissionKey.POSITION_LIST
    ]
  },
  {
    id: 'sim-cards',
    title: 'Sim Cards',
    type: 'item',
    classes: 'nav-item',
    url: '/console/sim-cards/list',
    icon: '#custom-clipboard',
    permissions: [
      PermissionKey.SIM_CARD_LIST,
    ]
  },
  {
    id: 'devices',
    title: 'Dispositivos',
    type: 'item',
    classes: 'nav-item',
    url: '/console/devices/list',
    icon: '#custom-cpu-charge',
    permissions: [
      PermissionKey.DEVICE_LIST,
    ]
  },
  {
    id: 'commands',
    title: 'Comandos',
    type: 'item',
    classes: 'nav-item',
    url: '/console/reports/commands/list',
    icon: '#custom-direct-inbox',
    permissions: [
      PermissionKey.MOBILE_COMMAND,
    ]
  },
  {
    id: 'mobiles',
    title: 'Vehiculos',
    type: 'item',
    classes: 'nav-item',
    url: '/console/mobiles/list',
    icon: '#custom-airplane',
    permissions: [
      PermissionKey.MOBILE_LIST,
    ]
  },
  {
    id: 'geofences',
    title: 'Geocercas',
    type: 'item',
    classes: 'nav-item',
    url: '/console/geofences/list',
    icon: '#custom-story',

    permissions: [
      PermissionKey.GEOFENCE_LIST,
    ]
  },
  {
    id: 'maintenance',
    title: 'Mantenimientos',
    type: 'item',
    classes: 'nav-item',
    url: '/console/maintenance/list',
    icon: '#custom-calendar-1',

    permissions: [
      PermissionKey.MAINTENANCE_LIST,
    ]
  },
  {
    id: 'reports',
    title: 'Reportes',
    type: 'collapse',
    classes: 'nav-item',
    icon: '#custom-graph',
    children: [
      {
        id: 'reports.positions',
        title: 'Posiciones',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/positions/list',
        permissions: [
          PermissionKey.POSITION_LIST,
        ]
      },
      {
        id: 'reports.commands',
        title: 'Comandos',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/commands/list',
        permissions: [
          PermissionKey.MOBILE_COMMAND,
        ]
      },
      {
        id: 'reports.consolidate',
        title: 'Consolidados diarios',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/daily-consolidates/list',
        permissions: [
          PermissionKey.CONSOLIDATE_LIST
        ]
      },
      {
        id: 'reports.consolidate-monthly',
        title: 'Consolidados mensuales',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/monthly-consolidates',
        permissions: [
          PermissionKey.CONSOLIDATE_LIST
        ]
      },
      {
        id: 'reports.activities',
        title: 'Actividades',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/activities/list',
        permissions: [
          PermissionKey.ACTIVITY_LIST
        ]
      },
      {
        id: 'reports.alarms',
        title: 'Alarmas',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/alarms/list',
        permissions: [
          PermissionKey.ALARM_LIST
        ]
      },
      {
        id: 'reports.geofences',
        title: 'Geocercas',
        type: 'item',
        classes: 'nav-item',
        url: '/console/reports/geofences/list',
        permissions: [
          PermissionKey.GEOFENCE_LIST
        ]
      },

    ]
  },
  {
    id: 'contacts',
    title: 'Contactos',
    type: 'item',
    classes: 'nav-item',
    url: '/console/contacts/list',
    icon: '#custom-call-calling',
    permissions: [PermissionKey.CONTACT_LIST]
  },
  {
    id: 'roles',
    title: 'Perfiles y licencias',
    type: 'item',
    classes: 'nav-item',
    url: '/console/profiles/list',
    icon: '#custom-shield',
    permissions: [PermissionKey.PROFILE_LIST]

  },
  {
    id: 'users',
    title: 'Usuarios',
    type: 'item',
    classes: 'nav-item',
    url: '/console/users/list',
    icon: '#custom-user',
    permissions: [PermissionKey.USER_LIST]
  },
  {
    id: 'properties',
    title: 'Propietarios',
    type: 'item',
    classes: 'nav-item',
    url: '/console/properties/list',
    icon: '#custom-box-1',
    permissions: [PermissionKey.PROPERTY_LIST]

  },

  {
    id: 'billing',
    title: "Facturacion",
    icon: "#custom-dollar-square",
    type: 'collapse',
    classes: 'nav-item',
    children: [
      {
        id: 'billing.my-billing',
        title: 'Mis planes',
        url: '/console/properties/list',
        type: 'item',
        classes: 'nav-item',
      },
      {
        id: 'billing.business',
        title: 'Negocios',
        type: 'item',
        classes: 'nav-item',
        url: '/console/properties/list',

      },
      {
        id: 'billing.list',
        title: 'Lista de facturas',
        type: 'item',
        classes: 'nav-item',
        url: '/console/properties/list',

      } ,
      {
        id: 'billing.services',
        title: 'Servicios',
        type: 'item',
        classes: 'nav-item',
        url: '/console/properties/list',

      },
      {
        id: 'billing.cashFlow',
        title: 'Flujo de caja',
        type: 'item',
        classes: 'nav-item',
        url: '/console/properties/list',

      },
      {
        id: 'billing.accountStatus',
        title: 'Estados de cuenta',
        type: 'item',
        classes: 'nav-item',
        url: '/console/properties/list',

      },
    ]
  },


  {
    id: 'system',
    type: 'group',
    title: 'Sistema',
    permissions: [PermissionKey.CHOICE_LIST],

    children: [
      {
        id: 'choices',
        title: 'Opciones de sistema',
        type: 'item',
        classes: 'nav-item',
        url: '/console/system/choices/list',
        icon: '#custom-setting-2',
        permissions: [PermissionKey.CHOICE_LIST]
      },
      {
        id: 'units',
        title: 'Unidades de medida',
        type: 'item',
        classes: 'nav-item',
        url: '/console/system/units/list',
        icon: '#custom-dollar-square',
        permissions: [PermissionKey.CHOICE_LIST]

      },
      {
        id: 'sensors',
        title: 'Sensores',
        type: 'item',
        classes: 'nav-item',
        url: '/console/system/sensors/list',
        icon: '#custom-flash',
        permissions: [PermissionKey.CHOICE_LIST]
      },
      {
        id: 'hardware',
        title: 'Equipos',
        type: 'item',
        classes: 'nav-item',
        url: '/console/system/hardware/list',
        icon: '#custom-cpu-charge',
        permissions: [PermissionKey.CHOICE_LIST]
      }
    ]
  }
];
